import { render, staticRenderFns } from "./BaseInputFeeling.vue?vue&type=template&id=2a0df64f&scoped=true&"
import script from "./BaseInputFeeling.vue?vue&type=script&lang=js&"
export * from "./BaseInputFeeling.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFeeling.vue?vue&type=style&index=0&id=2a0df64f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0df64f",
  null
  
)

export default component.exports